<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <!-- Snackbar for notifications -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000" top>
          {{ snackbar.message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
          </template>
        </v-snackbar>

        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text>
            <!-- Breadcrumbs -->
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item :to="item.to" :disabled="item.disabled" exact>
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <!-- Header -->
            <div v-if="isStaff" class="tw-mx-5 tw-font-bold tw-text-lg tw-text-black tw-tracking-wide">
              จัดการข้อมูลพื้นฐาน
            </div>

            <div class="tw-py-2 tw-px-5">
              <!-- Tabs -->
              <v-tabs v-model="currentTabIndex">
                <v-tab v-for="tab in crudTabs" :key="tab.key">
                  <v-icon left>{{ tab.icon }}</v-icon>
                  {{ tab.title }}
                </v-tab>
                <v-tab>
                  <v-icon left>mdi-file-upload</v-icon>
                  CSV Template
                </v-tab>
              </v-tabs>

              <!-- Tabs Content -->
              <v-tabs-items v-model="currentTabIndex">
                <!-- CRUD Tabs -->
                <v-tab-item v-for="tab in crudTabs" :key="tab.key">
                  <v-card flat class="mb-4">
                    <!-- Modern Card Wrapper -->
                    <div class="modern-card">
                      <v-form :ref="tab.key + 'Form'">
                        <v-container>
                          <v-row class="mb-8 px-4 pt-4" align="center">
                            <v-btn outlined color="info" @click="addRow(tab.key)">
                              <v-icon left>mdi-plus</v-icon>
                              เพิ่มข้อมูล
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn outlined color="success" class="mr-2" @click="exportData(tab.key)">
                              <v-icon left>mdi-file-export</v-icon>
                              Export
                            </v-btn>
                            <v-btn color="primary"
                                   :loading="saveLoading[tab.key]"
                                   :disabled="saveLoading[tab.key]"
                                   @click="saveData(tab.key)">
                              <v-icon left>mdi-content-save-outline</v-icon>
                              บันทึก
                            </v-btn>
                          </v-row>
                          <v-row v-for="(item, index) in masterData[tab.key]" :key="index" align="center">
                            <v-col
                              v-for="(field) in tab.fields"
                              :key="field.key"
                              :cols="field.cols"
                              class="my-0 py-0"
                            >
                              <v-text-field outlined v-model="item[field.key]" :label="field.label" dense persistent-placeholder></v-text-field>
                            </v-col>
                            <v-col>
                              <v-btn icon class="ma-0 pa-0 tw-transform tw--translate-y-3" color="error" @click="removeRow(tab.key, index)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </div>
                  </v-card>
                </v-tab-item>

                <!-- CSV Upload Tab -->
                <v-tab-item>
                  <v-card flat class="mb-4">
                    <div class="modern-card">
                      <v-form ref="csvForm">
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="2">
                              <v-select
                                v-model="csvDataType"
                                :items="csvDataTypes"
                                label="เลือกประเภทข้อมูล"
                                dense
                                outlined
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="5">
                              <v-file-input
                                v-model="csvFile"
                                label="เลือกไฟล์ CSV"
                                accept=".csv"
                                dense
                              ></v-file-input>
                            </v-col>
                          </v-row>
                          <v-row class="mt-2">
                            <v-col>
                              <v-btn 
                                :disabled="csvLoading || !csvDataType"
                                color="primary" @click="downloadCSVTemplate">
                                <v-icon left>mdi-download</v-icon>
                                ดาวน์โหลดเทมเพลต
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row class="mt-4">
                            <v-col>
                              <v-btn color="info"
                                     :loading="csvLoading"
                                     :disabled="csvLoading || !csvDataType || !csvFile"
                                     @click="handleCSVUpload">
                                <v-icon left>mdi-upload</v-icon>
                                อัพโหลดเทมเพลต
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </div>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import Papa from "papaparse";

export default {
  name: "AIMasterData",
  components: { Admin },
  data: () => ({
    snackbar: { show: false, message: "", color: "success" },
    items: [
      { text: "ตั้งค่า", disabled: false, to: { name: "Company.Settings" } },
      { text: "ข้อมูลพื้นฐาน", disabled: true },
    ],
    currentTabIndex: 0,
    // Store all master data in one object.
    masterData: {
      Expense: [],
      PaymentAccount: [],
      Vat: [],
      WithholdingTax: []
    },
    // Default rows for each master type.
    defaultRows: {
      Expense: { expCode: "", expName: "", acctCode: "", acctName: "", tranType: 0 },
      PaymentAccount: { payCode: "", payName: "", tranType: 1 },
      Vat: { vatCode: "", vatName: "", vatType: 0, acctCode: "", acctName: "", tranType: 0 },
      WithholdingTax: { whtCode: "", whtName: "", whtRate: "", acctCode: "", acctName: "", tranType: 1 }
    },
    // Firestore save merge settings.
    mergeConfig: {
      Expense: true,
      PaymentAccount: true,
      Vat: false,
      WithholdingTax: true
    },
    // Configuration for the CRUD tabs.
    crudTabs: [
      {
        title: "Expense",
        icon: "mdi-currency-usd",
        key: "Expense",
        fields: [
          { key: "expCode", label: "Expense Code", cols: 2 },
          { key: "expName", label: "Expense Name", cols: 3 },
          { key: "acctCode", label: "Account Code", cols: 2 },
          { key: "acctName", label: "Account Name", cols: 2 },
          { key: "tranType", label: "Tran Type", cols: 2 }
        ]
      },
      {
        title: "Payment",
        icon: "mdi-credit-card",
        key: "PaymentAccount",
        fields: [
          { key: "payCode", label: "Payment Code", cols: 4 },
          { key: "payName", label: "Payment Name", cols: 4 },
          { key: "tranType", label: "Tran Type", cols: 2 }
        ]
      },
      {
        title: "VAT",
        icon: "mdi-percent",
        key: "Vat",
        fields: [
          { key: "vatCode", label: "VAT Code", cols: 2 },
          { key: "vatName", label: "VAT Name", cols: 3 },
          { key: "vatType", label: "Type", cols: 1 },
          { key: "acctCode", label: "Acct Code", cols: 2 },
          { key: "acctName", label: "Acct Name", cols: 2 },
          { key: "tranType", label: "Tran", cols: 1 }
        ]
      },
      {
        title: "Withholding Tax",
        icon: "mdi-file-document",
        key: "WithholdingTax",
        fields: [
          { key: "whtCode", label: "WHT Code", cols: 2 },
          { key: "whtName", label: "WHT Name", cols: 3 },
          { key: "whtRate", label: "Rate", cols: 1 },
          { key: "acctCode", label: "Acct Code", cols: 2 },
          { key: "acctName", label: "Acct Name", cols: 2 },
          { key: "tranType", label: "Tran", cols: 1 }
        ]
      }
    ],
    // Loading states for Save buttons per tab and CSV upload.
    saveLoading: {
      Expense: false,
      PaymentAccount: false,
      Vat: false,
      WithholdingTax: false
    },
    csvLoading: false,
    companyID: null,
    isInitializing: false,
    // CSV Upload properties.
    csvFile: null,
    csvDataType: null,
    csvDataTypes: [
      { text: "Expense", value: "Expense" },
      { text: "PaymentAccount", value: "PaymentAccount" },
      { text: "Vat", value: "Vat" },
      { text: "WithholdingTax", value: "WithholdingTax" }
    ]
  }),
  created() {
    const companyID = this.$route.params.companyId;
    if (companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyID });
      this.companyID = companyID;
    }
  },
  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyApVendors: (state) => state.companies.selectedCompanyApVendors,
      prompts: (state) => state.companies.selectedCompanyApPrompts,
    }),
    isStaff() {
      return this.userCompany?.user?.isEngineer || this.userCompany?.isDeveloper;
    },
    isCompanyAdmin() {
      return this.userCompany?.isAdmin;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    notify(type, message) {
      this.snackbar = { show: true, message, color: type };
    },
    async init() {
      this.isInitializing = true;
      try {
        await Promise.all([
          this.$store.dispatch("user/getRoleUser", { companyId: this.companyID }),
          this.$store.dispatch("companies/fetchPrompts", { companyId: this.companyID }),
          this.$store.dispatch("companies/fetchApVendors", { companyId: this.companyID }),
        ]);
        await this.loadMasterData();
      } catch (error) {
        console.error("Error initializing:", error);
        this.notify("error", "เกิดข้อผิดพลาดในการดึงข้อมูล");
      }
      this.isInitializing = false;
    },
    async loadMasterData() {
      const keys = Object.keys(this.masterData);
      await Promise.all(
        keys.map(async (key) => {
          try {
            const doc = await fc.db
              .collection(`Companies/${this.companyID}/PurchaseInvoiceMaster`)
              .doc(key)
              .get();
            this.masterData[key] = doc.exists && doc.data().data ? doc.data().data : [];
          } catch (error) {
            console.error(error);
            this.notify("error", `Error fetching ${key} data`);
          }
        })
      );
    },
    // CRUD methods for master data.
    addRow(key) {
      this.masterData[key].unshift({ ...this.defaultRows[key] });
    },
    removeRow(key, index) {
      this.masterData[key].splice(index, 1);
    },
    async saveData(key) {
      this.saveLoading[key] = true;
      try {
        const docRef = fc.db
          .collection(`Companies/${this.companyID}/PurchaseInvoiceMaster`)
          .doc(key);
        await docRef.set(
          {
            timeCreate: fc.timestampNow,
            timeUpdate: fc.timestampNow,
            data: this.masterData[key],
          },
          { merge: this.mergeConfig[key] }
        );
        this.notify("success", `${key} data saved successfully`);
      } catch (error) {
        console.error(error);
        this.notify("error", `Error saving ${key} data`);
      } finally {
        this.saveLoading[key] = false;
      }
    },
    // CSV Upload Methods
    async handleCSVUpload() {
  if (!this.csvFile || !this.csvDataType) {
    this.notify("error", "Please select a data type and CSV file.");
    return;
  }
  this.csvLoading = true;
  Papa.parse(this.csvFile, {
    header: true,
    skipEmptyLines: true,
    complete: async (results) => {
      if (results.errors && results.errors.length > 0) {
        this.notify("error", "Error parsing CSV: " + results.errors[0].message);
      } else {
        // Update the local master data with the CSV results
        this.masterData[this.csvDataType] = results.data;
        // Persist the CSV data to Firestore so it remains after a refresh
        await this.saveData(this.csvDataType);
        this.notify("success", `CSV data loaded for ${this.csvDataType}`);
      }
      // Clear the CSV file and dropdown selection after upload
      this.csvFile = null;
      this.csvDataType = null;
      this.csvLoading = false;
    },
    error: (error) => {
      console.error(error);
      this.notify("error", "Error parsing CSV file.");
      this.csvLoading = false;
    },
  });
},

    exportData(key) {
      const data = this.masterData[key];
      if (!data || data.length === 0) {
        this.notify("warning", "ไม่มีข้อมูลสำหรับ Export");
        return;
      }
      const tab = this.crudTabs.find(t => t.key === key);
      const headers = tab.fields.map(f => f.key);
      const filtered = data.map(row => {
        const obj = {};
        headers.forEach(h => { obj[h] = row[h] !== undefined ? row[h] : ""; });
        return obj;
      });
      const csvContent = Papa.unparse(filtered);
      const fileNames = {
        Expense: "template-expense",
        PaymentAccount: "template-payment",
        Vat: "template-vat",
        WithholdingTax: "template-wht"
      };
      const fileName = fileNames[key] || key;
      const blob = new Blob(["﻿" + csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadCSVTemplate() {
      if (!this.csvDataType) {
        this.notify("error", "Please select a data type first.");
        return;
      }
      let csvContent = "";
      const dataToDownload = this.masterData[this.csvDataType] || [];
      if (dataToDownload.length === 0) {
        // If no data exists, generate a header row from the default row structure.
        const headers = Object.keys(this.defaultRows[this.csvDataType]);
        csvContent = headers.join(",") + "\n";
      } else {
        csvContent = Papa.unparse(dataToDownload);
      }
      const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `${this.csvDataType}_template.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none;
  padding-right: 8px !important;
  .v-btn {
    margin-left: 8px;
  }
}

/* Modern UI styling for the card content */
.modern-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  margin-bottom: 16px;
}
</style>
